import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

const AuditsHome = lazy(() => import("./web/AuditsHome.js").then((m) => ({ default: m.AuditsHome })));
const CheckPage = lazy(() => import("./web/CheckPage.js").then((m) => ({ default: m.CheckPage })));
const ManagePage = lazy(() => import("./web/ManagePage.js").then((m) => ({ default: m.ManagePage })));
const PrintPage = lazy(() => import("./web/PrintPage.js").then((m) => ({ default: m.PrintPage })));
const BuilderPage = lazy(() => import("./web/BuilderPage.js").then((m) => ({ default: m.BuilderPage })));

export default defineWebModule({ manifest, pages: { "": AuditsHome, "/check": CheckPage, "/manage": ManagePage, "/template": BuilderPage, "/print": PrintPage } });
